import React, {useState, useEffect, useContext, useMemo} from 'react';
import {Container, Row, Col} from 'reactstrap';
import {TimerImagePlaceholder, TimerHead} from '../svgs';
import {Field, Form, Formik} from 'formik';
import {AnswerCheckBox} from '../../helpers/formik';
import {EslidesEvent, Presentation} from '../../types/presentation';
import {gql, OperationVariables, QueryResult, useMutation, useQuery, useSubscription} from '@apollo/client';
import {Question} from '../../types/quiz';
import getEncodedImageUrl from '../../helpers/get-encoded-image';
import {useHistory, useLocation} from "react-router-dom";
import {presentation_by_pk, question_query, quiz_actions, quiz_actions_query} from '../../gql/quiz-gql'
import SocketClient from '../../helpers/connection';

import axios from 'axios';
import UserContext from '../../contexts/user';
import AttendeLiveAnswer from "./attende-live-answer";
import toast from "react-hot-toast";
import {Socket} from "socket.io-client";
import {useIntl} from "react-intl";
import {InLinePreLoader} from "../preloader";
import { getLiveQuizQuestionsForPresentation } from '../../helpers/get-live-quiz-questions';


const LiveQuestions: React.FC<{ locale: string; setLocale: any; ppt: Presentation; event: EslidesEvent;client:Socket }> = ({ppt,event,client}) => {

    const [startTimer, setStartTimer] = useState(true);
    const [result, setResultPage] = useState(false);
    const [waiting, setWaiting] = useState(false);
    const [disableNext, setDisableNext] = useState(false);
    const [disableQuestion, setDisableQuestion] = useState(false);
    const [countAdded, setCountAdded] = useState(false);
    const [isSubmitted, setIsSubmitted] = useState(false);
    const [questionIndex, setQuestionIndex] = useState(0);
    const [questionId, setQuestionId] = useState("");
    const [optionCount, setOptionCount] = useState(0);
    const [quizAction, setQuizAction] = useState("n");
    const intl = useIntl();
    const [actionData, setActionData] = useState({
        action: "",
        answered_count:undefined,
        id:undefined,
        presentation_id:undefined,
        question_index:0
    });
    const [ref, setRef] = useState<any>();
    const userContext = useContext(UserContext);
    const history = useHistory();
    const slug = document.location.pathname.split("/")[1] || "invalid";
    let token: any = localStorage.getItem(`token-${slug}`);
    const initialValues: { [key: string]: boolean } = useMemo(() => ({}), []);
    const formRef = React.useRef<any>();
    let optionIds: string[] = []
    const location = useLocation();
    const stateData = location.state;
    const [secondData, setSecondData] = useState<{
        questions: Array<Question>;
    }>();

    const liveQuestions = useMemo(
        () => getLiveQuizQuestionsForPresentation(ppt._id, secondData?.questions ?? []),
        [secondData, ppt._id]
    );

    useEffect(()=>{
        startCheckTimer()
    },[])


    // fetch question data from backend
    const {data: secondQueryData, loading: secondLoading, error: secondError} = useQuery<{
        questions: Array<Question>;

    }>(question_query, {
        variables: {
            presentation_id: ppt._id,
        },
        skip: !ppt,

    });

    // socket connect to presentation quiz
    useEffect(()=>{
        client.emit('join', {presentationId:ppt._id}, (response:any) => {
            console.log("join",response); // ok
        });
    },[])


    // on page load event assign questions to the state
    useEffect(() => {
        var data = location.state;

        // @ts-ignore
        if(data?.secondQueryData){
            // @ts-ignore
            setSecondData(data?.secondQueryData)
        }

        // @ts-ignore
        // setQuestionIndex(parseInt(data?.index??0));

        console.log("UPDATED_STATE",location.state,questionIndex)
    }, [location.state]);


    // set quiz question data
    useEffect(() => {
        setSecondData(secondQueryData)
    }, [secondQueryData]);

    useEffect(() => {
        if (liveQuestions.length > 0 && questionIndex >= liveQuestions.length) {
            setQuestionIndex(liveQuestions.length - 1);
        }
    }, [liveQuestions.length, questionIndex]);


    // check data from backend and sync actions
    function startCheckTimer() {
        console.log("check_quiz_action","Timer called");

        setInterval(async () => {
            console.log("setInterval socket",client.connected)
            if(!client.connected){
                client.connect();
                await axios
                    .post(
                        `${process.env.REACT_APP_API_ENDPOINT}/api/quiz/get-user-action`,
                        {
                            _id: ppt._id,
                        },
                        {
                            headers: {
                                Authorization: `Bearer ${token}`,
                            },
                        }
                    ).then((res) => {

                        if(res.data.status===200){
                            const type =  res.data.data.action;
                            setQuizAction(type);
                            if (type === 'timer_start') {
                                setDisableQuestion(false);
                            } else if (type === 'timer_stop') {
                                setDisableQuestion(true);
                            } else if (type === 'show_result') {
                                setWaiting(false);
                                setResultPage(true);
                            } else if (type === 'timer_end') {
                                //submitAnswer(optionIds,secondData?.questions[questionIndex].id,userContext?.user?.id)
                                setWaiting(true)
                                console.log('action-updated',result,waiting);
                            } else if (type === 'final') {
                                //submitAnswer(optionIds,secondData?.questions[questionIndex].id,userContext?.user?.id)
                                setWaiting(true)
                                nextQuestionEvent(parseInt(res.data.data.question_index));
                            }
    
                            if( parseInt(res.data.data.question_index) !== questionIndex) {
                                nextQuestionEvent(res.data.data.question_index);
                            }
    
                            if (type === 'next_question') {
                                if( parseInt(res.data.data.question_index) !== questionIndex) {
                                    setWaiting(false);
                                    setResultPage(false);
                                    setOptionCount(0);
                                    nextQuestionEvent(res.data.data.question_index);
                                    optionIds = []
                                }
                            }
                        }
                    });
            }


        },8000)
    }


    // update option change and broadcast socket message to all clients
    function optionBroadcast(jsonData:any) {
        console.log('loginBroadcast',jsonData)
        const headers = {
            'Content-Type': 'application/json',
        }

        axios.post(`${process.env.REACT_APP_SOCKET_URL}/option-count-change`, jsonData, {
            headers: headers
        })
            .then((response) => {
                console.log('loginBroadcast s',response)
            })
            .catch((error) => {
                console.log('loginBroadcast e',error)
            })
    }

    // based on moderator action perform same action in attendee page  { actiondata : indicate the moderator actions }
    useEffect(() => {
        if(actionData){
            let type= actionData.action;
            setQuizAction(type);
            let index = actionData.question_index
            if (type === 'timer_start') {
                setDisableQuestion(false);
            } else if (type === 'timer_stop') {
                setDisableQuestion(true);
            } else if (type === 'show_result') {
                setWaiting(false);
                setResultPage(true);
            } else if (type === 'timer_end') {
                //submitAnswer(optionIds,secondData?.questions[questionIndex].id,userContext?.user?.id)
                setWaiting(true)
                console.log('action-updated',result,waiting);
            } else if (type === 'next_question' && liveQuestions.length > 0) {

                if( actionData.question_index  <=  liveQuestions.length && actionData.question_index !==questionIndex ) {
                    setWaiting(false);
                    setResultPage(false);
                    setCountAdded(false)
                    console.log("setCountAdded(false) 2")
                    setOptionCount(0);
                    nextQuestionEvent(index);
                    optionIds = []
                }
            }

        }
    }, [actionData]);



    // set quiz question data
    // send signal for the attendee select option
    useEffect(() => {

        const optionList = optionIds;
        console.log("optionList",liveQuestions[questionIndex]);


        var correctAnswerCount = liveQuestions[questionIndex]?.options?.filter(e => e.correct).length ?? 0;
        console.log("correctAnswerCount",correctAnswerCount);

        // check options selected same count as correct answer then disable selection
        if(optionIds.length === correctAnswerCount){
            setDisableQuestion(true);
            console.log("correctAnswerCount","true");
        }else {
            setDisableQuestion(false);
        }

        if (optionList.length === 1 && !countAdded) {

            console.log("answer_count 2", 'options ',optionList,optionList.length,countAdded);
            console.log("answer_count 2", 'answer_count_in');
            optionBroadcast({presentationId:ppt._id,createdAt:Date.now(),action:'answer_count_in'});
            setCountAdded(true)
        } else if (optionList.length === 0 && countAdded)  {
            console.log("answer_count 3", 'answer_count_out');
            console.log("answer_count 3", 'options ',optionList,optionList.length,countAdded);
            optionBroadcast({presentationId:ppt._id,createdAt:Date.now(),action:'answer_count_out'});
            setCountAdded(false)
        }
        if (optionList.length!==0 ){
            submitAnswer(optionList,liveQuestions[questionIndex]?.id,userContext?.user?.id)

        }

    }, [optionCount]);

    // configure socket connection and message handle [client : socket client object]
    useEffect(() => {
        // eslint-disable-next-line react-hooks/exhaustive-deps
        console.log('action-updated---007',result,waiting);
        if(client){
            client.on('quiz-action-updates', function (data:any){
                setActionData(data);
                console.log('quiz-action-updates------ 2',data);
                console.log('action-updated---3',result,waiting);
            });

            // block back press event
            window.onpopstate = function(event:PopStateEvent) {
                history.go(1);
            };

        }

    },[]);

    // assign question id to the state
    useEffect(() => {
        // eslint-disable-next-line react-hooks/exhaustive-deps
        setQuestionId(liveQuestions[questionIndex]?.id ?? "");
    }, [questionIndex, liveQuestions]);


    // move to next question
    let nextQuestionEvent = (index: any) => {
        setQuestionIndex(index);
    }

    //submit answer to backend for the result
    async function submitAnswer(option_ids: string[], questionId: string | undefined, userId: string | undefined) {
        //console.log("SUBMIT ANSWER",secondData,questionId)
        if(!isSubmitted){
            setIsSubmitted(true)
            await axios
                .post(
                    `${process.env.REACT_APP_API_ENDPOINT}/api/quiz/submit-answer`,
                    {
                        questionId: liveQuestions[questionIndex]?.id,
                        userId: userContext.user?.id,
                        optionIds: option_ids,
                        presentationId:ppt._id,
                    },
                    {
                        headers: {
                            Authorization: `Bearer ${token}`,
                        },
                    }
                ).then((res) => {
                    setIsSubmitted(false)
                    console.log('submitAnswer res',res.data);
                });
        }

    }

    console.log("App-Loaded",waiting,result);

    return (

        <div className="quiz-live-screen-container overflow-hidden" style={{height:'inherit'}}>
            <div className="grid">
                <div className="timer-with-question timer-with-question-attendee" style={{alignItems: 'unset'}}>
                    <div className="event-details">
                        <Row className="align-items-center">
                            <Col md={2}> {event?.logo ?
                                <img
                                    height={90}
                                    src={getEncodedImageUrl(event.logo, 110, 110, "contain")}
                                    alt="logo"
                                /> : <img height={45} src="/images/logo-default.png" alt=""/>
                            }  </Col>
                            <Col></Col>
                            <Col md={6}><h5>{ppt.name}</h5></Col>
                        </Row>
                    </div>
                    <div className="timer-image-container">
                        <div className="image-placeholder">
                            {
                                liveQuestions.length > 0 && liveQuestions[questionIndex]?.image  ?
                                    <div style={{width: 180, height: 140}}>
                                        <img className='question-image'
                                             src={getEncodedImageUrl(liveQuestions[questionIndex].image)}
                                             alt="Question"/></div> : <TimerImagePlaceholder/>
                            }
                        </div>
                        <h5 style={{paddingTop:'30px'}}>question {questionIndex + 1}/{liveQuestions.length??"0"}</h5>
                        <p>{liveQuestions[questionIndex]?.question ?? ""}</p>
                    </div>
                    <div className='d-none d-md-block '>
                        <span>Powered by</span>
                        <img src="/images/e-slides-logo.png" alt="e-slides-logo"/>
                    </div>
                </div>
                <div className="answers-main answers-main-attendee">

                    {secondLoading || liveQuestions.length === 0 ? (
                        <div className='container'>
                            <div className='row'>
                                <Col >
                                    <div className="quiz-live-answers-container" style={{justifyContent:'center',display:'flex'}}>
                                        <InLinePreLoader/>
                                    </div>
                                </Col>
                                <div>
                                </div>
                            </div>
                        </div>

                    ) : (
                        /*show question components*/
                        !result && !waiting ?
                            <div className='container'>
                                <div className='row'>
                                    <Col>
                                        <div className="quiz-live-answers-container m-b-20 overflow-hidden">
                                            <Formik
                                                innerRef={formRef}
                                                onSubmit={async values => {
                                                }

                                                }
                                                initialValues={initialValues}

                                            >
                                                {({values}) => {
                                                    // console.log("CHANGE FORM", values)

                                                    const option_ids: string[] = Object.keys(values)
                                                        .filter((key) => values[key])
                                                        .map((key) => key.split('#')[1]);

                                                    optionIds = option_ids;

                                                    console.log("CHANGE FORM", option_ids)
                                                    // const padclass = answers.length > 4 ? answers.length > 6 ? 'padClassMax' : 'padClassAttendeeActive' : '';
                                                    const padclass = ''
                                                    if (liveQuestions[questionIndex].options.length <= 4) {
                                                        return (
                                                            <Form>
                                                                {
                                                                    liveQuestions[questionIndex].options.map((answer, i) => (
                                                                        <Field
                                                                            key={`answer#${answer.id}`}
                                                                            component={AnswerCheckBox}
                                                                            alphabet={String.fromCharCode(i + 97)}
                                                                            name={`answer#${answer.id}`}
                                                                            id={`answer#${answer.id}`}
                                                                            padclass={`padClassAttendeeActive`}
                                                                            label={answer.option}
                                                                            active={!optionIds.includes(answer.id!) && disableQuestion}
                                                                            optionCountChange={setOptionCount}
                                                                            optionCountValue={optionCount}

                                                                        />
                                                                    ))
                                                                }
                                                            </Form>
                                                        )
                                                    } else if (liveQuestions[questionIndex].options.length <= 6) {
                                                        var code = 96;
                                                        return (
                                                            <Form>
                                                                <div className='container-fluid overflow-hidden '>
                                                                    <div className="row ">
                                                                        <div className="col ">
                                                                            {
                                                                                liveQuestions[questionIndex].options.slice(0, 3).map((answer, i) => (

                                                                                    <Field
                                                                                        key={`answer#${answer.id}`}
                                                                                        component={AnswerCheckBox}
                                                                                        alphabet={String.fromCharCode(++code)}
                                                                                        name={`answer#${answer.id}`}
                                                                                        id={`answer#${answer.id}`}
                                                                                        padclass={`padClassMax`}
                                                                                        label={answer.option}
                                                                                        active={!optionIds.includes(answer.id!) && disableQuestion}
                                                                                        optionCountChange={setOptionCount}
                                                                                        optionCountValue={optionCount}
                                                                                    />
                                                                                ))
                                                                            }
                                                                        </div>
                                                                        <div className="col ">
                                                                            {
                                                                                liveQuestions[questionIndex].options.slice(3, 6).map((answer, i) => (

                                                                                    <Field
                                                                                        key={`answer#${answer.id}`}
                                                                                        component={AnswerCheckBox}
                                                                                        alphabet={String.fromCharCode(++code)}
                                                                                        name={`answer#${answer.id}`}
                                                                                        id={`answer#${answer.id}`}
                                                                                        padclass={`padClassMax`}
                                                                                        label={answer.option}
                                                                                        active={!optionIds.includes(answer.id!) && disableQuestion}
                                                                                        optionCountChange={setOptionCount}
                                                                                        optionCountValue={optionCount}
                                                                                    />
                                                                                ))
                                                                            }
                                                                        </div>
                                                                    </div>

                                                                </div>
                                                            </Form>
                                                        )

                                                    } else if (liveQuestions[questionIndex].options.length <= 8) {
                                                        var code = 96;
                                                        return (
                                                            <Form>
                                                                <div className='container-fluid overflow-hidden'>
                                                                    <div className="row ">
                                                                        <div className="col ">
                                                                            {
                                                                                liveQuestions[questionIndex].options.slice(0, 4).map((answer, i) => (

                                                                                    <Field
                                                                                        key={`answer#${answer.id}`}
                                                                                        component={AnswerCheckBox}
                                                                                        alphabet={String.fromCharCode(++code)}
                                                                                        name={`answer#${answer.id}`}
                                                                                        id={`answer#${answer.id}`}
                                                                                        padclass={'padClass20'}
                                                                                        label={answer.option}
                                                                                        active={!optionIds.includes(answer.id!) && disableQuestion}
                                                                                        optionCountChange={setOptionCount}
                                                                                        optionCountValue={optionCount}
                                                                                    />
                                                                                ))
                                                                            }
                                                                        </div>
                                                                        <div className="col ">
                                                                            {
                                                                                liveQuestions[questionIndex].options.slice(4, 8).map((answer, i) => (
                                                                                    <Field
                                                                                        key={`answer#${answer.id}`}
                                                                                        component={AnswerCheckBox}
                                                                                        alphabet={String.fromCharCode(++code)}
                                                                                        name={`answer#${answer.id}`}
                                                                                        id={`answer#${answer.id}`}
                                                                                        padclass={'padClass20'}
                                                                                        label={answer.option}
                                                                                        active={!optionIds.includes(answer.id!) && disableQuestion}
                                                                                        optionCountChange={setOptionCount}
                                                                                        optionCountValue={optionCount}
                                                                                    />
                                                                                ))
                                                                            }
                                                                        </div>
                                                                    </div>

                                                                </div>
                                                            </Form>
                                                        )
                                                    } else {
                                                        var code = 96;
                                                        return (
                                                            <Form>
                                                                <div className='container-fluid overflow-hidden'>
                                                                    <div className="row ">
                                                                        <div className="col ">
                                                                            {
                                                                                liveQuestions[questionIndex].options.slice(0, 5).map((answer, i) => (

                                                                                    <Field
                                                                                        key={`answer#${answer.id}`}
                                                                                        component={AnswerCheckBox}
                                                                                        alphabet={String.fromCharCode(++code)}
                                                                                        name={`answer#${answer.id}`}
                                                                                        id={`answer#${answer.id}`}
                                                                                        padclass={padclass}
                                                                                        label={answer.option}
                                                                                        active={!optionIds.includes(answer.id!) && disableQuestion}
                                                                                        optionCountChange={setOptionCount}
                                                                                        optionCountValue={optionCount}
                                                                                    />
                                                                                ))
                                                                            }
                                                                        </div>
                                                                        <div className="col ">
                                                                            {
                                                                                liveQuestions[questionIndex].options.slice(5, liveQuestions[questionIndex].options.length).map((answer, i) => (

                                                                                    <Field
                                                                                        key={`answer#${answer.id}`}
                                                                                        component={AnswerCheckBox}
                                                                                        alphabet={String.fromCharCode(++code)}
                                                                                        name={`answer#${answer.id}`}
                                                                                        id={`answer#${answer.id}`}
                                                                                        padclass={padclass}
                                                                                        label={answer.option}
                                                                                        active={!optionIds.includes(answer.id!) && disableQuestion}
                                                                                        optionCountChange={setOptionCount}
                                                                                        optionCountValue={optionCount}
                                                                                    />
                                                                                ))
                                                                            }
                                                                        </div>
                                                                    </div>

                                                                </div>
                                                            </Form>
                                                        )


                                                    }
                                                }}
                                            </Formik>
                                        </div>
                                    </Col>
                                </div>
                            </div> : <></>
                    )
                    }
                    {/*display result page components  */}
                    {!waiting && result && liveQuestions.length > 0 && <Container fluid>
                        <Row>
                            <Col>
                                <div className="quiz-live-answers-container m-t-20 m-b-20">
                                    <h5 className="d-none d-md-block" style={{color: 'white'}}>Question {questionIndex + 1}/{liveQuestions.length}</h5>
                                    <p className="q d-none d-md-block"
                                       style={{color: 'white'}}>{liveQuestions[questionIndex]?.question}</p>
                                    {
                                        liveQuestions[questionIndex].options.map((answer, index) => (
                                            <AttendeLiveAnswer
                                                totalAnswersAggregate={123}
                                                answerLength={liveQuestions[questionIndex].options.length}
                                                key={answer.id}
                                                alphabet={String.fromCharCode(index + 97)}
                                                answer={answer.option}
                                                totalAnswers={25}
                                                value={answer.correct}
                                            />
                                        ))
                                    }
                                </div>
                            </Col>
                        </Row>
                    </Container>
                    }
                    {/*display waiting page when quiz stops*/}
                    {waiting && <Container fluid>
                        <Row>
                            <Col>
                                <div className="quiz-live-answers-container m-t-60">
                                    <Row className='p-2'>

                                        <Col className="text-center ">
                                            <img className="m-t-5" height={120} src="/images/tutorial-1.svg"
                                                 alt="quiz"/>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col lg={10} xl={8} md={12} className="mx-auto text-center text-white">
                                            <p className="quiz-body-text">
                                                <br/> <span style={{
                                                fontSize: 21,
                                                color: 'white'
                                            }}>{intl.formatMessage({id: 'quiz.waiting.msg'})}</span>

                                            </p>
                                        </Col>
                                    </Row>
                                </div>
                            </Col>
                        </Row>
                    </Container>
                    }
                </div>
            </div>
        </div>
    )
}

export default LiveQuestions;


